export const listMixin = {
  data() {
    return {
      data: []
    }
  },
  methods: {
    onFetchData() {
      this.req.get().then( res => {
        this.data = res.data.data
      })
    },
    onFetchByID() {
      return this.req.get_id(this.id).then( res => {
        this.form = res.data.data
      })
    },
    onDelete() {
      this.req.delete(this.id).then( () => {
        this.onClose()
      })
    },
    onPost() {
      this.req.post(this.fd).then( () => {
        this.onClose()
      })
    },
    onPut() {
      this.req.put(this.fd).then( () => {
        this.onClose()
      })
    }
  }
}